module.exports = __webpack_public_path__ + "static/img/watch2.ac18ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/watch2.png
// module id = o/YI
// module chunks = 8